var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbContainer"},[_c('a-breadcrumb',{attrs:{"separator":">"}},_vm._l((_vm.path),function(item,index){return _c('a-breadcrumb-item',{key:index},[_c('span',{staticClass:"mbx",on:{"click":function($event){return _vm.go(item.names)}}},[_vm._v(_vm._s(item.name))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }